// src/components/CreateShowForm.js
import React, { useState, useEffect } from 'react';
import { useMutation, useQuery, gql } from '@apollo/client';
import './CreateShowForm.css';

const CREATE_SHOW = gql`
  mutation CreateShow($input: CreateShowInput!) {
    createShow(input: $input) {
      id
      title
    }
  }
`;

const GET_VENUE_OPTIONS = gql`
  query GetAllVenues {
    getAllVenues {
      id
      name
    }
  }
`;

const CreateShowForm = ({ artistPageId, refetch }) => {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    date: '',
    startTime: '',
    endTime: '',
    venuePageId: '',
    manualVenueName: '',
    manualVenueAddress: '',
    isTicketed: false,
    isFreeTicket: false,
    ticketPrice: '',
    perks: [],
    isRecurring: false,
    recurrencePattern: 'WEEKLY',
    recurrenceEndDate: '',
  });

  const [newPerk, setNewPerk] = useState('');
  const token = sessionStorage.getItem('token');

  const { data: venuesData } = useQuery(GET_VENUE_OPTIONS);

  const [createShow, { loading }] = useMutation(CREATE_SHOW, {
    context: { headers: { Authorization: `Bearer ${token}` } },
    onCompleted: () => {
      setFormData({
        title: '', description: '', date: '', startTime: '', endTime: '',
        venuePageId: '', manualVenueName: '', manualVenueAddress: '',
        isTicketed: false, isFreeTicket: false, ticketPrice: '', perks: [],
        isRecurring: false, recurrencePattern: 'WEEKLY', recurrenceEndDate: '',
      });
      setNewPerk('');
      refetch?.();
    }
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const input = {
      ...formData,
      artistPageId: parseInt(artistPageId),
      ticketPrice: parseFloat(formData.ticketPrice) || 0,
      perks: formData.perks.map(name => ({ name }))
    };
    createShow({ variables: { input } });
  };

  const handlePerkAdd = () => {
    if (newPerk) {
      setFormData(prev => ({ ...prev, perks: [...prev.perks, newPerk] }));
      setNewPerk('');
    }
  };

  return (
    <form className="create-show-form" onSubmit={handleSubmit}>
      <h2>Create Show</h2>
      <input placeholder="Title" value={formData.title} onChange={e => setFormData({ ...formData, title: e.target.value })} />
      <textarea placeholder="Description" value={formData.description} onChange={e => setFormData({ ...formData, description: e.target.value })} />
      <input type="date" value={formData.date} onChange={e => setFormData({ ...formData, date: e.target.value })} />
      <input type="time" value={formData.startTime} onChange={e => setFormData({ ...formData, startTime: e.target.value })} />
      <input type="time" value={formData.endTime} onChange={e => setFormData({ ...formData, endTime: e.target.value })} />

      <label>Choose Venue:</label>
      <select value={formData.venuePageId} onChange={e => setFormData({ ...formData, venuePageId: e.target.value, manualVenueName: '', manualVenueAddress: '' })}>
        <option value=''>-- Select Venue --</option>
        {venuesData?.getAllVenues.map(v => <option key={v.id} value={v.id}>{v.name}</option>)}
      </select>

      {!formData.venuePageId && (
        <>
          <input placeholder="Manual Venue Name" value={formData.manualVenueName} onChange={e => setFormData({ ...formData, manualVenueName: e.target.value })} />
          <input placeholder="Manual Venue Address" value={formData.manualVenueAddress} onChange={e => setFormData({ ...formData, manualVenueAddress: e.target.value })} />
        </>
      )}

      <label>
        <input type="checkbox" checked={formData.isTicketed} onChange={e => setFormData({ ...formData, isTicketed: e.target.checked })} />
        Ticketed?
      </label>

      {formData.isTicketed && (
        <>
          <label>
            <input type="checkbox" checked={formData.isFreeTicket} onChange={e => setFormData({ ...formData, isFreeTicket: e.target.checked })} />
            Free Ticket?
          </label>
          {!formData.isFreeTicket && (
            <input type="number" placeholder="Ticket Price" value={formData.ticketPrice} onChange={e => setFormData({ ...formData, ticketPrice: e.target.value })} />
          )}
        </>
      )}

      <div>
        <h4>Perks</h4>
        <input value={newPerk} onChange={e => setNewPerk(e.target.value)} placeholder="Add a perk" />
        <button type="button" onClick={handlePerkAdd}>+ Add Perk</button>
        <ul>{formData.perks.map((perk, i) => <li key={i}>{perk}</li>)}</ul>
      </div>

      <label>
        <input type="checkbox" checked={formData.isRecurring} onChange={e => setFormData({ ...formData, isRecurring: e.target.checked })} />
        Recurring Weekly?
      </label>
      {formData.isRecurring && (
        <div>
        <label>
        Show expiry date:
        </label>
        <input type="date" value={formData.recurrenceEndDate} onChange={e => setFormData({ ...formData, recurrenceEndDate: e.target.value })} />
        </div>
      )}

      <button type="submit" disabled={loading}>{loading ? 'Creating...' : 'Create Show'}</button>
    </form>
  );
};

export default CreateShowForm;
